import React from "react";
import {createPortal} from "react-dom";
import {isDevToolsEnabled} from "../../../../../helpers";
import {Button, Colors} from "../../../../../ui";

const DEV_TOOLS_Z_INDEX = 1400;
const EDGE_SPACING = 16;
const DEV_TOOLS_WIDGET_SIZE = 40;
const WIDGET_GAP = 12;

interface DevAutofillBarProps {
  onFill: () => void;
}

export const DevAutofillBar = ({onFill}: DevAutofillBarProps) => {
  if (!isDevToolsEnabled()) return null;

  return createPortal(
    <Button
      size={"small"}
      buttonType={"text"}
      onClick={onFill}
      sx={{
        position: "fixed",
        top: EDGE_SPACING + DEV_TOOLS_WIDGET_SIZE + WIDGET_GAP,
        right: EDGE_SPACING,
        zIndex: DEV_TOOLS_Z_INDEX,
        bgcolor: Colors.orange._100,
        color: Colors.orange._900,
        border: `1px dashed ${Colors.orange._800}`,
        boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
        "&:hover, &:focus, &:active": {
          bgcolor: Colors.orange._200,
        },
      }}
    >
      Autofill test data
    </Button>,
    document.body
  );
};
